import { transformEnabledFacets } from '@activebrands/core-web/utils/transform-enabled-facets';
import { graphql, useStaticQuery } from 'gatsby';

const useSortConfigQuery = () => {
    const { application } = useStaticQuery(
        graphql`
            {
                application {
                    data {
                        config {
                            sortConfig {
                                enabledFacets {
                                    ...Facet
                                    ...FacetGroup
                                }
                            }
                        }
                    }
                }
            }
        `
    );
    const { enabledFacets } = application.data.config.sortConfig;
    return {
        enabledFacets: transformEnabledFacets(enabledFacets),
    };
};

export default useSortConfigQuery;
